import api from './axios';

// Dönemler
export const getTerms = (params) => api.get('/terms', { params });
export const createTerm = (data) => api.post('/terms', data);
export const updateTerm = (id, data) => api.put(`/terms/${id}`, data);
export const deleteTerm = (id) => api.delete(`/terms/${id}`);
export const getTermHolidays = (termId) => api.get(`/terms/${termId}/holidays`);
export const addTermHoliday = (termId, data) => api.post(`/terms/${termId}/holidays`, data);
export const deleteTermHoliday = (termId, holidayId) => api.delete(`/terms/${termId}/holidays/${holidayId}`);
// data: { days: {gunNo: {start, end}}, classroom_ids: [], preview?: true }
// preview=true hiçbir şey yazmaz, yalnızca ne olacağını sayar.
export const generateTermSessions = (termId, data = {}) =>
  api.post(`/terms/${termId}/generate-sessions`, data);
export const getTermPrices = (termId) => api.get(`/terms/${termId}/prices`);
export const addTermPrice = (termId, data) => api.post(`/terms/${termId}/prices`, data);
export const updateTermPrice = (termId, priceId, data) => api.put(`/terms/${termId}/prices/${priceId}`, data);
export const deleteTermPrice = (termId, priceId) => api.delete(`/terms/${termId}/prices/${priceId}`);

// Derslikler
export const getClassrooms = (params) => api.get('/classrooms', { params });
export const createClassroom = (data) => api.post('/classrooms', data);
export const updateClassroom = (id, data) => api.put(`/classrooms/${id}`, data);
export const deleteClassroom = (id) => api.delete(`/classrooms/${id}`);
export const getClassroomCourses = (classroomId) => api.get(`/classrooms/${classroomId}/courses`);
export const syncClassroomCourses = (classroomId, data) => api.post(`/classrooms/${classroomId}/courses`, data);

// Kampanyalar
export const getCampaigns = (params) => api.get('/discount-campaigns', { params });
export const createCampaign = (data) => api.post('/discount-campaigns', data);
export const updateCampaign = (id, data) => api.put(`/discount-campaigns/${id}`, data);
export const deleteCampaign = (id) => api.delete(`/discount-campaigns/${id}`);

// Bildirim Şablonları
export const getNotificationTemplates = () => api.get('/notification-templates');
export const updateNotificationTemplate = (id, data) => api.put(`/notification-templates/${id}`, data);